import { render } from "./AuEthAddress.vue?vue&type=template&id=05e868be"
import script from "./AuEthAddress.vue?vue&type=script&lang=js"
export * from "./AuEthAddress.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__